import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { useUserInfor } from "../../../../Context/User";
import { ListarAtendimentosClienteController } from "../../../../Controllers/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoControllers";
import { ListarEtapasPorCategoriaETipoCasoController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarVariasSubCategoriasController } from "../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarTipoPesoAtendimentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import {
    IAtendimentoClienteRequest,
    TModoGestaoAtendimento,
} from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import StorageManagerCapys from "../../../../Tools/Storage";

interface IFilterFormDataInterface {
    DT_INICIAL_IN?: string;
    DT_INICIAL_FN?: string;
    DT_FINAL_IN?: string;
    DT_FINAL_FN?: string;
    DS_STATUS_CASO?: string;
    ID_MOTIVO_CANCELAMENTO?: number;
    ID_EMPREENDIMENTO?: string | number;
    ID_UNIDADE?: number;
    ID_CASO?: number;
    FL_ANDAMENTO?: number;
    FL_CONTEM?: boolean;
    PESQUISA?: string;
    ID_USUARIO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_CATEGORIA_ATENDIMENTO?: number[];
    ID_SUBCATEGORIA?: number;
    ID_CONTA: number;
    ID_ACOMPANHAMENTO?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO?: string[] /* array de arrays 'stringados' - ['8', '12,15,37', '38, 99'] */;
    ID_TIPOS_PESOS_ATENDIMENTOS?: number[];
    ID_TIPO_CANAL_ATENDIMENTO?: 0;
}

const filtroInicial = {
    ID_CONTA: 0,
    ID_ACOMPANHAMENTO: 0,
    DS_STATUS_CASO: "Aberto",
    ID_CATEGORIA_ATENDIMENTO: [],
    ID_TIPOS_PESOS_ATENDIMENTOS: [],
    ID_ETAPA_CATEGORIA_ATENDIMENTO: [],
    ID_CASO: 0,
    DS_NOME_CONTA: "",
};

export default function useAtendimento(atendimento: TModoGestaoAtendimento) {
    const FormMethods = useForm<IFilterFormDataInterface>();
    const { register, handleSubmit, reset, watch, setValue, control } =
        FormMethods;

    const { PageFilter, setPage } =
        usePaginationFilter<IAtendimentoClienteRequest>();

    const tipoAtendimento =
        atendimento === "USUARIO" || atendimento === "ACOMPANHAMENTO"
            ? "MEUS"
            : atendimento;
    const filtroGestaoStorage =
        new StorageManagerCapys<IAtendimentoClienteRequest>(
            `FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE_${tipoAtendimento}`,
            "session"
        );
    const FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE = filtroGestaoStorage.get();
    const { UserInfor } = useUserInfor();

    const filter = useRef<IAtendimentoClienteRequest>(
        filtroGestaoStorage.get() ?? filtroInicial
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    const [idTipoPeso, setIdTipoPeso] = useState<number[]>([]);
    const [categoriaAtendimento, setCategoriaAtendimento] = useState<number[]>(
        []
    );
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const [valueEtapa, setValueEtapa] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const [valueSubCategoria, setValueSubCategoria] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const watchStatusCaso = watch("DS_STATUS_CASO");

    const selectInputRef = useRef<any>();
    const tipoRef = useRef<any>();

    const limparFiltros = () => {
        selectInputRef.current?.clearValue();
        tipoRef.current.clearValue();
        setCategoriaAtendimento([]);
        setValueEtapa(null);
        setValueSubCategoria(null);
    };

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos, setOptions]);

    const {
        value: listarClientes,
        loading: listarClientesLoading,
        execute: updateList,
    } = useAsyncEffect(
        () =>
            ListarAtendimentosClienteController(
                filter.current,
                PageFilter.page,
                atendimento
            ),
        [PageFilter]
    );

    const totalPaginas = listarClientes?.PAGINAS;

    const { value: lstSubCategoria } = useAsyncEffect(async () => {
        if (categoriaAtendimento.length > 0)
            return ListarVariasSubCategoriasController(
                idEmpreendimento,
                categoriaAtendimento
            );
    }, [categoriaAtendimento]);

    const subCategoriasOptions = lstSubCategoria
        ?.map((s) => ({
            label: s.DS_SUBCATEGORIA_ATENDIMENTO || "",
            value: s.ID_SUB_CATEGORIA_ATENDIMENTO || 0,
        }))
        .filter((option) => option.label && option.value);

    const { value: lstEtapas } = useAsyncEffect(async () => {
        if (categoriaAtendimento.length > 0) {
            return ListarEtapasPorCategoriaETipoCasoController(
                ACESSOS.ATENDIMENTO.ID_MODULO,
                categoriaAtendimento
            );
        }
    }, [categoriaAtendimento]);

    const etapasOptions = lstEtapas?.map((e) => ({
        label: e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        value: e.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
    }));

    const { value: lstTipoPeso } = useAsyncEffect(() =>
        ListarTipoPesoAtendimentoController()
    );

    const lstTipoPesoOptions = lstTipoPeso?.map((tipo) => ({
        label: tipo.DS_TIPO_PESO_ATENDIMENTO,
        value: tipo.ID_TIPO_PESO_ATENDIMENTO,
    }));

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    return {
        register,
        handleSubmit,
        reset,
        setValue,
        control,
        watchStatusCaso,
        limparFiltros,
        show,
        setShow,
        modal,
        setModal,
        idEmpreendimento,
        setIdEmpreendimento,
        idTipoPeso,
        setIdTipoPeso,
        categoriaAtendimento,
        setCategoriaAtendimento,
        options,
        setOptions,
        valueEtapa,
        setValueEtapa,
        valueSubCategoria,
        setValueSubCategoria,
        selectInputRef,
        tipoRef,
        customStyles,
        subCategoriasOptions,
        etapasOptions,
        lstTipoPesoOptions,
        listarCanalAtendimento,
        filtroGestaoStorage,
        FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE,
        setPage,
        UserInfor,
        filter,
        listarClientes,
        listarClientesLoading,
        updateList,
        totalPaginas,
        filtroInicial,
    };
}
